<template>
  <v-flex>

    <!-- Confirmación de eliminación de tarifa -->
    <v-dialog v-model="showConfirmacionEliminacionTarifa" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">
              Confirmación para eliminar tarifa
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'"
            @click="showConfirmacionEliminacionTarifa = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea eliminar la tarifa de {{ this.tarifaSelec != null ? this.tarifaSelec.fecha_desde :
                '' }} a {{ this.tarifaSelec != null ? this.tarifaSelec.fecha_hasta : '' }}?
            </p>
          </v-row>
          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarTarifa()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionTarifa = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para buscar etapa -->
    <v-dialog v-model="dialogFormularioBuscarEtapa" width="1400" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Buscar Etapa Existente</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="dialogFormularioBuscarEtapa = false; caminoSeleccionado = null">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <v-col cols="6">
              <v-card v-for="categoria in this.categorias" :key="categoria.id" class="mb-2" color="rgb(250, 250, 250)">
                <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                  <v-chip label class="mr-1" color="rgb(60, 60, 60)">
                    <span v-bind:style="{ color: 'white' }">
                      {{ categoria.caminos.length }} Caminos
                    </span>
                  </v-chip>
                  <v-divider class="mx-2" inset vertical></v-divider>
                  <v-toolbar-title :dark="!dark">{{ categoria.titulo }}</v-toolbar-title>

                  <v-spacer></v-spacer>
                </v-toolbar>

                <v-card-text>

                  <v-card class="mb-1 elevation-0" v-for="camino in categoria.caminos" :key="camino.id"
                    :color="caminoSeleccionado && caminoSeleccionado.id === camino.id ? 'blue lighten-3' : 'rgb(230, 230, 230)'"
                    @click="seleccionarCamino(camino)"
                    style="cursor: pointer;">
                    <v-card-text>
                      <v-row>
                        <span class="ml-1 mt-1 mb-1">
                          {{ camino.titulo }}
                        </span>
                        

                      </v-row>
                    </v-card-text>

                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>

            <v-divider vertical></v-divider>
            <v-col cols="6">
              <v-card v-if="caminoSeleccionado" color="rgb(250, 250, 250)">
                <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                  <v-chip label class="mr-1" color="rgb(60, 60, 60)">
                    <span v-bind:style="{ color: 'white' }">
                      {{ caminoSeleccionado.etapas ? caminoSeleccionado.etapas.length : 0 }} Etapas
                    </span>
                  </v-chip>
                  <v-divider class="mx-2" inset vertical></v-divider>
                  <v-toolbar-title :dark="!dark">{{ caminoSeleccionado.titulo }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                  <v-card class="mb-1 elevation-1" v-for="etapa in caminoSeleccionado.etapas" :key="etapa.id"
                    color="rgb(230, 230, 230)">
                    <v-card-text>
                      <v-row align="center">
                        <v-col>
                          <span class="ml-1 mt-1 mb-1">{{ etapa.titulo }}</span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip label class="mr-1 px-1" link color="green lighten-2" @click="_agregarEtapaExistente(etapa)"
                          v-on="on">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-chip>
                      </template>
                      <span>Agregar Etapa</span>
                    </v-tooltip>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-row v-if="!caminoSeleccionado.etapas || caminoSeleccionado.etapas.length === 0" class="mt-4" justify="center">
                    <span class="text-caption grey--text">Este camino no tiene etapas registradas</span>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row v-else class="mt-8" justify="center">
                <span class="text-caption grey--text">Selecciona un camino para ver sus etapas</span>
              </v-row>
            </v-col>

          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirmación de eliminación de etapa -->
    <v-dialog v-model="showConfirmacionEliminacionEtapa" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Confirmación para eliminar etapa</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacionEtapa = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-0 mx-4" justify="center">
            <p class="text-center" style="font-size: 1.2rem;" :dark="dark">
              ¿Está seguro que desea eliminar la etapa {{ this.etapaSelec != null ? this.etapaSelec.titulo : '' }}?
            </p>
          </v-row>
          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarEtapa()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionEtapa = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar</span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Formulario para crear o editar una etapa -->
    <v-dialog v-if="this.modelEtapa" v-model="dialogFormularioEtapa" :max-width="1400" persistent>
      <etapa-formulario @cerrarFormularioEtapa="_cerrarUpdateFormularioEtapa"
        @soloCerrar="dialogFormularioEtapa = false" :modelEtapa="this.modelEtapa" :accion="this.accionEtapa"
        :camino="this.modelCamino" />
    </v-dialog>

    <v-dialog v-if="this.modelTarifa" v-model="dialogFormularioTarifa" :max-width="800" persistent>
      <camino-tarifa-formulario @cerrarFormularioTarifa="_cerrarFormularioTarifa"
        @soloCerrar="dialogFormularioTarifa = false" :modelTarifa="this.modelTarifa" :accion="this.accionTarifa"
        :camino="this.modelCamino" />
    </v-dialog>

    <v-card :color="'rgb(250, 250, 250)'" class="elevation-0 mb-4">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">Camino</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarCamino(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarCamino(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-6" dense>
          <v-col cols="7" class="camino-form-column">
            <v-row v-if="esCaminoAMedida" dense class="mx-4 mb-2">
              <v-select
                v-model="modelCamino.subcategoria_id"
                outlined
                dense
                clearable
                :dark="dark"
                autocomplete="off"
                label="Subcategoría"
                :items="subcategoriasCaminosAMedida"
                item-text="titulo"
                item-value="id"
              ></v-select>
            </v-row>

            <v-card class="mx-4">
              <v-card-title>
                <v-tabs v-model="tab" grow>
                  <v-tab v-for="(language, index) in languages" :key="index">
                    {{ language }}
                  </v-tab>
                </v-tabs>
              </v-card-title>

              <v-card-text>
                
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.codigo" outlined label="Código" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.subtitulo"
                            label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo_EN" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off"
                            v-model="modelCamino.subtitulo_EN" label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen_EN" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion_EN" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mx-4">
                          <v-text-field v-model="modelCamino.titulo_DE" outlined label="Nombre" dense :dark="dark"
                            autocomplete="off"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-text-field outlined dense :dark="dark" autocomplete="off"
                            v-model="modelCamino.subtitulo_DE" label="Subtitulo"></v-text-field>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="10" outlined v-model="modelCamino.resumen_DE" :dark="dark"
                            label="Resumen"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-textarea rows="20" outlined v-model="modelCamino.descripcion_DE" :dark="dark"
                            label="Descripcion"></v-textarea>
                        </v-row>


                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <v-card class="mb-6 mx-0 mt-12" color="rgb(250, 250, 250)">
              <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                <v-toolbar-title :dark="!dark">Servicios Incluidos</v-toolbar-title>
                <v-divider class="mx-2" inset vertical></v-divider>

                <v-spacer></v-spacer>

              </v-toolbar>

              <v-card-text>
                <v-data-table hide-default-footer locale="es" v-if="serviciosIncluidos.length > 0" dense
                  :headers="headersServicios" :items="serviciosIncluidos"
                  :server-items-length="serviciosIncluidos.length" class="elevation-1 alternating-rows bordered-table">
                  <template v-slot:[`item.esta_habilitado`]="{ item }">
                    <v-icon v-if="item.esta_habilitado" color="green" style="font-size: 2rem;"
                      @click="ChangeHabilitarClienteServicio(item, false)">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" style="font-size: 2rem;"
                      @click="ChangeHabilitarClienteServicio(item, true)">mdi-close-circle</v-icon>
                  </template>

                  <template v-slot:[`item.esta_activo`]="{ item }">
                    <v-icon v-if="item.esta_activo" color="green" style="font-size: 2rem;"
                      @click="ChangeActivoServicio(item, false)">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" style="font-size: 2rem;"
                      @click="ChangeActivoServicio(item, true)">mdi-close-circle</v-icon>
                  </template>

                  <!--  <template v-slot:[`item.action`]="{ item, index }">
                    <v-chip class="mr-2 px-0" label small :color="'blue lighten-2'" text-color="white" link
                      @click="_editarTarifa(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-chip>
                    <v-chip class="mr-1 px-0" label small color="red lighten-2" text-color="white" link
                      @click="_showDeleteTarifa(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-chip>
                  </template> -->
                  <template v-slot:no-data>
                    No hay servicios incluidos para este camino
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>

            <v-card class="mb-6 mx-0" color="rgb(250, 250, 250)">
              <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                <v-toolbar-title :dark="!dark">Servicios Agregados Posibles</v-toolbar-title>
                <v-divider class="mx-2" inset vertical></v-divider>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-data-table hide-default-footer locale="es" v-if="serviciosAgregadosPosibles.length > 0" dense
                  :headers="headersServicios" :items="serviciosAgregadosPosibles"
                  :server-items-length="serviciosAgregadosPosibles.length"
                  class="elevation-1 alternating-rows bordered-table">

                  <template v-slot:[`item.esta_habilitado`]="{ item }">
                    <v-icon v-if="item.esta_habilitado" color="green" style="font-size: 2rem;"
                      @click="ChangeHabilitarClienteServicio(item, false)">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" style="font-size: 2rem;"
                      @click="ChangeHabilitarClienteServicio(item, true)">mdi-close-circle</v-icon>
                  </template>

                  <template v-slot:[`item.esta_activo`]="{ item }">
                    <v-icon v-if="item.esta_activo" color="green" style="font-size: 2rem;"
                      @click="ChangeActivoServicio(item, false)">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" style="font-size: 2rem;"
                      @click="ChangeActivoServicio(item, true)">mdi-close-circle</v-icon>
                  </template>

                  <!--  <template v-slot:[`item.action`]="{ item, index }">
                    <v-chip class="mr-2 px-0" label small :color="'blue lighten-2'" text-color="white" link
                      @click="_editarTarifa(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-chip>
                    <v-chip class="mr-1 px-0" label small color="red lighten-2" text-color="white" link
                      @click="_showDeleteTarifa(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-chip>
                  </template> -->
                  <template v-slot:no-data>
                    No hay servicios incluidos para este camino
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>



          <v-col cols="5" class="camino-form-column camino-form-column-right">
            <v-card class="mb-6" color="rgb(250, 250, 250)">
              <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                <v-chip label class="mr-1" color="rgb(60, 60, 60)">
                  <span v-bind:style="{ color: 'white' }">
                    {{ modelCamino.etapas.length }}
                  </span>
                </v-chip>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-toolbar-title :dark="!dark">Etapas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip label class="mr-2" link :color="'blue lighten-1'" @click="_buscarEtapa">
                  <span v-bind:style="{ color: 'white' }">
                    Buscar Etapa
                  </span>
                </v-chip>
                <v-chip label class="mr-2" link :color="colorAccent1" @click="_crearEtapa">
                  <span v-bind:style="{ color: 'white' }">
                    Nueva Etapa
                  </span>
                </v-chip>
              </v-toolbar>

              <v-card-text>

                <v-card class="mb-1 elevation-0" v-for="etapa in modelCamino.etapas" :key="etapa.id"
                  color="rgb(230, 230, 230)">
                  <v-card-title>
                    <div v-if="etapa.imagen_base64" class="mr-4">
                      <img :src="etapa.imagen_base64" alt="Imagen de Etapa" width="40" height="40"
                        style="border-radius: 10%;" />
                    </div>
                    <div v-else class="mr-4"
                      style="width: 40px; height: 40px; background-color: white; border-radius: 10%;">
                    </div>

                    <h5>
                      {{ etapa.titulo }}
                    </h5>
                    <v-spacer></v-spacer>


                    <v-chip v-if="(modelCamino.etapas.length > 0 && etapa.id != modelCamino.etapas[0].id)" label
                      class="mr-1 px-1" color="transparent">
                      <v-icon color="transparent">mdi-arrow-up-bold</v-icon>
                    </v-chip>
                    <v-chip v-if="(etapa.id != modelCamino.etapas[0].id)" label class="mr-1 px-1" link
                      color="green lighten-1" @click="_updateEtapaOrden(modelCamino.id, etapa.id, 'SUBIR')">
                      <v-icon color="white">mdi-arrow-up-bold</v-icon>
                    </v-chip>

                    <v-chip
                      v-if="(modelCamino.etapas.length > 0 && etapa.id == modelCamino.etapas[modelCamino.etapas.length - 1].id)"
                      label class="mr-1 px-1" color="transparent">
                      <v-icon color="transparent">mdi-arrow-down-bold</v-icon>
                    </v-chip>
                    <v-chip v-if="etapa.id != modelCamino.etapas[modelCamino.etapas.length - 1].id" label
                      class="mr-1 px-1" link color="green lighten-1"
                      @click="_updateEtapaOrden(modelCamino.id, etapa.id, 'BAJAR')">
                      <v-icon color="white">mdi-arrow-down-bold</v-icon>
                    </v-chip>




                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip label class="mr-1 px-1" link :color="colorAccent3" @click="_editarEtapa(etapa)"
                          v-on="on">
                          <v-icon color="white">mdi-pencil</v-icon>
                        </v-chip>
                      </template>
                      <span>Editar Etapa</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip label class="mr-1 px-1" link color="red lighten-2" @click="_showDeleteEtapa(etapa)"
                          v-on="on">
                          <v-icon color="white">mdi-delete</v-icon>
                        </v-chip>
                      </template>
                      <span>Eliminar Etapa</span>
                    </v-tooltip>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card>

                <v-row class="ml-8 mt-8 mb-4">
                  <v-switch v-model="modelCamino.con_etapa_final" :dark="dark" dense
                    label="Haciendo noche en la última etapa." @change="changeEtapaFinal()"></v-switch>
                </v-row>
              </v-card-text>
            </v-card>

            <v-row dense class="mx-4 mt-16">
              <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.dificultad"
                label="Dificultad" :items="dificultades"></v-select>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.distancia"
                label="Distancia"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense type="number" :dark="dark" autocomplete="off" v-model="modelCamino.noches"
                label="Noches"></v-text-field>
            </v-row>

            <!-- <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_ind"
                label="Precio Individual"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_doble"
                label="Precio Doble"></v-text-field>
            </v-row>

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.precio_triple"
                label="Precio Triple"></v-text-field>
            </v-row> -->

            <v-row dense class="mx-4">
              <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelCamino.suplemento"
                label="Suplemento (%) para Julio y Agosto"></v-text-field>
            </v-row>

            <v-card class="mb-6 mx-0" color="rgb(250, 250, 250)">
              <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
                <v-toolbar-title :dark="!dark">Tarifas por años</v-toolbar-title>
                <v-divider class="mx-2" inset vertical></v-divider>

                <v-spacer></v-spacer>
                <v-chip label class="mr-2" link :color="colorAccent1" @click="_createTarifa">
                  <span v-bind:style="{ color: 'white' }">
                    Nueva Tarifa
                  </span>
                </v-chip>
              </v-toolbar>

              <v-card-text>
                <v-data-table hide-default-footer locale="es"
                  v-if="modelCamino.tarifas && modelCamino.tarifas.length > 0" dense :headers="headers"
                  :items="modelCamino.tarifas" :server-items-length="modelCamino.tarifas.length"
                  class="elevation-1 alternating-rows bordered-table">

                  <template v-slot:[`item.fecha_desde`]="{ item }">
                    {{ formatearFecha(item.fecha_desde) }}
                  </template>

                  <template v-slot:[`item.fecha_hasta`]="{ item }">
                    {{ formatearFecha(item.fecha_hasta) }}
                  </template>

	                  <template v-slot:[`item.action`]="{ item, index }">
	                    <v-chip v-if="tarifaTieneSuplemento(item)" class="mr-2 px-0" label small color="green lighten-1" text-color="white" link
	                      @click="_editarTarifa(item)">
	                      <v-icon>mdi-currency-eur</v-icon>
	                    </v-chip>
	                    <v-chip class="mr-2 px-0" label small :color="'blue lighten-2'" text-color="white" link
	                      @click="_editarTarifa(item)">
	                      <v-icon>mdi-pencil</v-icon>
	                    </v-chip>
                    <v-chip class="mr-1 px-0" label small color="red lighten-2" text-color="white" link
                      @click="_showDeleteTarifa(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    No hay tarifas registradas para este camino
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>


          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EtapaFormulario from "@/components/formularios/EtapaFormulario.vue";
import CaminoTarifaFormulario from "@/components/formularios/CaminoTarifaFormulario.vue";

export default {
  name: "CaminoFormulario",
  components: {
    EtapaFormulario,
    CaminoTarifaFormulario,
  },
  data: () => ({
    loading: false,

    modelEtapa: null,
    accionEtapa: "",
    dialogFormularioEtapa: false,
    showConfirmacionEliminacionEtapa: false,

    modelTarifa: null,
    accionTarifa: "",
    dialogFormularioTarifa: false,
    showConfirmacionEliminacionTarifa: false,

    dialogFormularioBuscarEtapa: false,
    caminoSeleccionado: null, // Para almacenar el camino seleccionado

    tab: null, // Para controlar el tab activo
    languages: ['Español', 'Inglés', 'Alemán'], // Nombres de los idiomas

	    headers: [
	      { text: 'DESDE', value: 'fecha_desde', sortable: false },
	      { text: 'HASTA', value: 'fecha_hasta', sortable: false },
	      { text: 'IND', value: 'precio_ind', sortable: false, width: '90px', align: 'center' },
	      { text: 'DOBLE', value: 'precio_doble', sortable: false, width: '90px', align: 'center' },
	      { text: 'TRIPLE', value: 'precio_triple', sortable: false, width: '90px', align: 'center' },
	      { text: '', value: 'action', sortable: false, align: 'center', width: '140px' },
	    ],

    headersServicios: [
      { text: 'SERVICIO', value: 'titulo', sortable: false },
      { text: 'HABILITADO PARA CLIENTE', value: 'esta_habilitado', sortable: false, width: '200px', align: 'center' },
      { text: 'ACTIVO', value: 'esta_activo', sortable: false, width: '100px', align: 'center' },
      // { text: '', value: 'action', sortable: false, align: 'center', width: '100px' },
    ],


  }),

  props: {
    modelCamino: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "dificultades",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("etapas", ["etapas", "etapaSelec"]),
    ...mapState("caminos", ["tarifaSelec"]),
    ...mapState("categorias", ["categorias"]),

    serviciosIncluidos() {
      if (!this.modelCamino?.servicios) return [];
      return this.modelCamino.servicios.filter(servicio => servicio.esta_incluido);
    },

    serviciosAgregadosPosibles() {
      if (!this.modelCamino?.servicios) return [];
      return this.modelCamino.servicios.filter(servicio => !servicio.esta_incluido);
    },

    esCaminoAMedida() {
      return Number(this.modelCamino?.categoria_id) === 11;
    },

    subcategoriasCaminosAMedida() {
      console.log('categorias:', this.categorias);
      return this.categorias.filter((categoria) => Number(categoria.id) !== 11);
    },
  },


  mounted() {
    console.log('modelCamino:', this.modelCamino);
    if (this.modelCamino && this.modelCamino.subcategoria_id === undefined) {
      this.$set(this.modelCamino, "subcategoria_id", null);
    }
  },

  methods: {
    ...mapActions("caminos", ["getCaminos", "crearCamino", "updateCamino",
      "createTarifa", "updateTarifa",
      "deleteTarifa", "eliminarEtapasCamino", "updateCaminoConEtapaFinal",
      "updateServicioHabilitadoCliente", "updateServicioActivo", "updateEtapaOrden", "agregarEtapaExistente"]),
    ...mapMutations("etapas", ["setEtapaSelec"]),
    ...mapMutations("caminos", ["setTarifaSelec"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioCamino");
    },

    _cerrarUpdateFormularioEtapa(etapa) {
      if (etapa != null) {
        if (this.accionEtapa == "crear") {
          this.modelCamino.etapas.push(etapa);
        } else if (this.accionEtapa == "editar") {
          let index = this.modelCamino.etapas.findIndex((e) => e.id == etapa.id);
          this.modelCamino.etapas[index] = etapa;
        }
      }
      this.dialogFormularioEtapa = false;

    },

    async changeEtapaFinal() {
      await this.updateCaminoConEtapaFinal([
        this.access_token,
        this.modelCamino.id,
        this.modelCamino.con_etapa_final,
      ]);
      console.log('modelCamino.con_etapa_final:', this.modelCamino.con_etapa_final);
    },

    async _updateEtapaOrden(camino_id, etapa_id, accion) {
      const res = await this.updateEtapaOrden([
        this.access_token,
        camino_id,
        etapa_id,
        accion,
      ]);
      console.log('res:', res);
      if (res != null && res.id == camino_id) {
        this.modelCamino.etapas = res.etapas;
      }
    },

    _cerrarFormularioTarifa(tarifa) {
      if (tarifa != null) {
        if (this.accionTarifa == "crear") {
          this.modelTarifa = null;
          this.dialogFormularioTarifa = false;
        } else if (this.accionTarifa == "editar") {
          this.modelTarifa = null;
          this.dialogFormularioTarifa = false;
        }
      }
      this.dialogFormularioTarifa = false;
    },

    async _guardarCamino(cerrar) {
      this.loading = true;
      if (!this.esCaminoAMedida) {
        this.modelCamino.subcategoria_id = null;
      }
      if (this.accion == "crear") {
        var res = await this.crearCamino([
          this.access_token,
          this.modelCamino,
        ]);
        const params = {};
        await this.getCaminos([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateCamino([
          this.access_token,
          this.modelCamino,
        ]);
      }
      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },

    _crearEtapa() {
      this._inicializarModelEtapa();
      this.accionEtapa = 'crear';
      this.dialogFormularioEtapa = true;
    },



    _inicializarModelEtapa() {
      this.modelEtapa = {
        id: null,
        titulo: null,
        descripcion: null,
        inicio_punto: null,
        final_punto: null,
        dificultad: null,
        duracion: null,
        distancia: null,
        imagen_base64: null,
      };
    },

	    _inicializarModelTarifa() {
	      this.modelTarifa = {
	        id: null,
	        camino_id: this.modelCamino.id,
	        fecha_desde: null,
	        fecha_hasta: null,
	        precio_ind: "0",
	        precio_doble: "0",
	        precio_triple: "0",
	        suplemento_fecha_desde: null,
	        suplemento_fecha_hasta: null,
	        suplemento: null,
	      };
	    },

    _createTarifa() {
      this._inicializarModelTarifa();
      this.accionTarifa = 'crear';
      this.dialogFormularioTarifa = true;
    },

    _editarTarifa(item) {
      this.setTarifaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.tarifaSelec));
      this.modelTarifa = temp;
      this.accionTarifa = 'editar';
      this.dialogFormularioTarifa = true;
    },

    _showDeleteTarifa(item) {
      this.setTarifaSelec(item);
      this.showConfirmacionEliminacionTarifa = true;
    },

    async _eliminarTarifa() {
      this.showConfirmacionEliminacionTarifa = false;
      if (this.tarifaSelec != null) {
        await this.deleteTarifa([this.access_token, this.tarifaSelec.id]);
      }
    },

    _editarEtapa(item) {
      this.setEtapaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.etapaSelec));
      this.modelEtapa = temp;
      this.accionEtapa = 'editar';
      this.dialogFormularioEtapa = true;
    },

    _showDeleteEtapa(etapa) {
      this.setEtapaSelec(etapa);
      this.showConfirmacionEliminacionEtapa = true;
    },

    async _eliminarEtapa() {
      this.showConfirmacionEliminacionEtapa = false;
      if (this.etapaSelec != null) {
        await this.eliminarEtapasCamino([this.access_token, this.modelCamino.id, this.etapaSelec.id]);
      }
    },

    async ChangeHabilitarClienteServicio(servicio, habilitado) {
      const res = await this.updateServicioHabilitadoCliente([
        this.access_token,
        this.modelCamino.id,
        servicio.id,
        habilitado,
      ]);
      if (res != null && res.id == this.modelCamino.id) {
        this.modelCamino.servicios = res.servicios;
      }
    },

    async ChangeActivoServicio(servicio, activo) {
      const res = await this.updateServicioActivo([
        this.access_token,
        this.modelCamino.id,
        servicio.id,
        activo,
      ]);
      if (res != null && res.id == this.modelCamino.id) {
        this.modelCamino.servicios = res.servicios;
      }
    },

    _buscarEtapa() {
      console.log('categorias:', this.categorias);
      this.dialogFormularioBuscarEtapa = true;
    },

    seleccionarCamino(camino) {
      this.caminoSeleccionado = camino;
      console.log('Camino seleccionado:', camino);
    },

    async _agregarEtapaExistente(etapa) {
      const res = await this.agregarEtapaExistente([
        this.access_token,
        this.modelCamino.id,
        etapa.id,
      ]);
      if (res != null && res.id == this.modelCamino.id) {
        this.modelCamino.etapas = res.etapas;
      }
    },

	    formatearFecha(fecha) {
	      if (!fecha) return '';
	      const date = new Date(fecha);
	      if (Number.isNaN(date.getTime())) {
	        return fecha; 
      }
      const dia = String(date.getDate()).padStart(2, '0');
	      const mes = String(date.getMonth() + 1).padStart(2, '0');
	      const año = date.getFullYear();
	      return `${dia}/${mes}/${año}`;
	    },

	    tarifaTieneSuplemento(tarifa) {
	      return Number(tarifa?.suplemento || 0) > 0;
	    },
	  },
};
</script>

<style scoped>
.camino-form-column {
  min-width: 0;
}

.camino-form-column-right {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  padding-left: 12px;
}
</style>
